module.exports = __webpack_public_path__ + "img/1165.21ff191f.jpg";